module.exports = __webpack_public_path__ + "img/usdt_select.c50ff581.png";